import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticsPanelComponent } from './statistics-panel.component';
import { NgApexchartsModule } from 'ng-apexcharts';



@NgModule({
  declarations: [
    StatisticsPanelComponent
  ],
  exports: [
    StatisticsPanelComponent
  ],
  imports: [
    CommonModule,
    NgApexchartsModule
  ]
})
export class StatisticsPanelModule { }
